import React from 'react';
import { ButtonBase } from '@material-ui/core';
import { alpha, makeStyles } from '@material-ui/core/styles';

interface ButtonDateSwitchProps {
  date: Date | null;
  children?: React.ReactNode;
}

const ButtonDateSwitch = ({ date, children }: ButtonDateSwitchProps) => {
  const classes = useStyles(!date);

  return <ButtonBase className={classes.root}>{children}</ButtonBase>;
};

const useStyles = makeStyles(theme => ({
  root: {
    background: isLive =>
      `linear-gradient(45deg, ${isLive ? alpha(theme.palette.error.main, 0.25) : alpha(theme.palette.primary.main, 0.35)}, ${alpha(theme.palette.primary.main, isLive ? 0.3 : 0.15)})`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(2, 3.5),
    minHeight: 64,
    minWidth: 200,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    transition: 'background-color 0.3s ease',
    [theme.breakpoints.down('xs')]: {},
    '&:hover, &$focusVisible': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5, 2.75),
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: undefined,
      gap: theme.spacing(1),
    },
  },
}));

export default ButtonDateSwitch;
